<div class="container py-4">
  <div class="card shadow-sm">
    <div class="d-flex justify-content-center align-items-center p-3">
      @if (imageUrl) {
        <img [src]="imageUrl" class="rounded" alt="Review Image"
          style="max-width: 100%; height: auto; object-fit: contain;" />
      }
    </div>
    <div class="card-body text-center">
      <h5 class="card-title text-primary">{{ title }}</h5>
      <div class="d-flex justify-content-center align-items-center gap-3 mb-3">
        <div>
          <i class="fa fa-eye"></i> {{ viewCount }} views
        </div>
        <div>
          <button class="btn btn-light" (click)="likeProduct()">
            <i class="fa fa-heart text-danger"></i> {{ likes }} likes
          </button>
        </div>
        <div>
          <select [(ngModel)]="selectedTag" class="form-select d-inline-block" style="max-width: 200px;">
            <option [ngValue]="null" disabled selected>Character</option>
            @for (character of availableTags; track character) {
              <option [ngValue]="character">
                {{ character.emoji }} {{ character.label }}
              </option>
            }
          </select>
          <button class="btn btn-primary ms-2" [disabled]="!selectedTag" (click)="addTag()">
            Add
          </button>
        </div>
      </div>
      <hr />
      <div class="text-start">
        <h6>Legend:</h6>
        <ul class="list-inline small">
          <li class="list-inline-item">🐐 = GOAT (Greatest of All Time)</li>
          <li class="list-inline-item">🦀 = Crab (Negative influencer)</li>
          <li class="list-inline-item">💰 = Value for Money</li>
          <li class="list-inline-item">😴 = Lazy</li>
          <li class="list-inline-item">💼 = Strong Leader</li>
          <li class="list-inline-item">👎 = Poor Performer</li>
        </ul>
      </div>
    </div>
  </div>
</div>